import React from "react";

const TermsOfService = () => {
  return (
    <div className="max-w-4xl mx-auto px-6 py-20">
      <h1 className="text-4xl font-bold mb-6">Terms of Service</h1>

      <p className="mb-4">
        By using the Stash Masters website and services, you agree to the
        following terms and conditions.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">Services</h2>
      <p className="mb-4">
        Stash Masters provides carpentry, transport, airport transfer, shuttle
        services, and vehicle rental services as described on this website.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">Bookings</h2>
      <p className="mb-4">
        Service bookings are subject to availability and confirmation by our
        team.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">Liability</h2>
      <p className="mb-4">
        While we strive to provide reliable services, Stash Masters is not
        liable for damages resulting from misuse of our services.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">Contact</h2>
      <p>
        For any questions regarding these terms, please contact Stash Masters.
      </p>
    </div>
  );
};

export default TermsOfService;
